import { crearVariables } from './crearVariables';
import { crearManosJugadores } from './crearManosJugadores';

/**
 * Crea todos los parámetros del BlackJack
 * @param {*} scene
 */
export function creacionParametrosPrincipal(scene) {
  crearVariables(scene);
  crearManosJugadores(scene);
}
